module.exports = __webpack_public_path__ + "static/media/Prohibition on export of telecommunications equipment.38df63a6.png";